import {
  persistedDataIsFilled,
  selectedAddressIsFilled,
} from './postcodeSelectorUtils';

export const postcodeSelectorInitialState = (id, persistedData = {}) => ({
  id,
  loading: false,
  postcode: '',
  renderAddressSelector: false,
  fetchedAddresses: [],
  addressList: [],
  selectedAddress: persistedData,
  addressFieldsPreviouslyShown: !!(
    persistedDataIsFilled(persistedData) ||
    selectedAddressIsFilled(persistedData, id)
  ),
  addressFieldsShown: !!(
    persistedDataIsFilled(persistedData) ||
    selectedAddressIsFilled(persistedData, id)
  ),
  showManualEntryButton: false,
  submittedAddress: null,
  addressFieldsValues: {
    [`${id}Number`]: persistedData.house_number || '',
    [`${id}Line1`]: persistedData.address_line_1 || '',
    [`${id}Line2`]: persistedData.address_line_2 || '',
    [`${id}Line3`]: persistedData.address_line_3 || '',
    [`${id}Line4`]: persistedData.address_line_4 || '',
    [`${id}Postcode`]: persistedData.postcode || '',
  },
});

export const setIsLoading = payload => ({
  type: 'SET_IS_LOADING',
  payload,
});

export const setPostcodeAndReset = payload => ({
  type: 'SET_POSTCODE_AND_RESET',
  payload,
});

export const initiateSearch = () => ({
  type: 'INITIATE_SEARCH',
});

export const setRenderAddressSelector = payload => ({
  type: 'SET_RENDER_ADDRESS_SELECTOR',
  payload,
});

export const setFetchedAddresses = payload => ({
  type: 'SET_FETCHED_ADDRESSES',
  payload,
});

export const setAddressList = payload => ({
  type: 'SET_ADDRESS_LIST',
  payload,
});

export const setSelectedAddress = payload => ({
  type: 'SET_SELECTED_ADDRESS',
  payload,
});

export const populateAddressFields = payload => ({
  type: 'POPULATE_ADDRESS_FIELDS',
  payload,
});

export const setAddressFieldsPreviouslyShown = payload => ({
  type: 'SET_ADDRESS_FIELDS_PREVIOUSLY_RENDERED',
  payload,
});

export const setAddressFieldsShown = payload => ({
  type: 'SET_ADDRESS_FIELDS_RENDERED',
  payload,
});

export const setField = (field, value) => ({
  type: 'SET_ADDRESS_FIELD',
  field,
  payload: value,
});
export const resetAddressFields = () => ({
  type: 'RESET_ADDRESS_FIELDS',
});

export const manualEntry = () => ({
  type: 'MANUAL_ENTRY',
});

export const forceManualEntry = () => ({
  type: 'FORCE_MANUAL_ENTRY',
});

export const setSubmittedAddress = payload => ({
  type: 'SET_SUBMITTED_ADDRESS',
  payload,
});

export const postcodeSelectorReducer = (state, action) => {
  switch (action.type) {
    case 'SET_IS_LOADING':
      return {
        ...state,
        loading: action.payload,
      };
    case 'SET_POSTCODE_AND_RESET':
      return {
        ...state,
        postcode: action.payload,
        renderAddressSelector: false,
        selectedAddress: null,
        addressFieldsShown: false,
        addressFieldsPreviouslyShown: false,
      };
    case 'INITIATE_SEARCH':
      return {
        ...state,
        selectedAddress: null,
        renderAddressSelector: true,
        showManualEntryButton: true,
      };
    case 'SET_RENDER_ADDRESS_SELECTOR':
      return {
        ...state,
        renderAddressSelector: action.payload,
      };
    case 'SET_FETCHED_ADDRESSES':
      return {
        ...state,
        fetchedAddresses: action.payload,
      };
    case 'SET_ADDRESS_LIST':
      return {
        ...state,
        addressList: action.payload,
      };
    case 'SET_SELECTED_ADDRESS':
      return {
        ...state,
        selectedAddress: action.payload,
      };
    case 'SET_ADDRESS_FIELDS_PREVIOUSLY_RENDERED':
      return {
        ...state,
        addressFieldsPreviouslyShown: action.payload,
      };
    case 'SET_ADDRESS_FIELDS_RENDERED':
      return {
        ...state,
        addressFieldsShown: action.payload,
      };
    case 'MANUAL_ENTRY':
      return {
        ...state,
        postcode: '',
        selectedAddress: null,
        renderAddressSelector: false,
        addressFieldsShown: true,
      };
    case 'FORCE_MANUAL_ENTRY':
      return {
        ...state,
        postcode: '',
        selectedAddress: null,
        renderAddressSelector: false,
        showManualEntryButton: false,
        addressFieldsShown: true,
      };
    case 'SET_SUBMITTED_ADDRESS':
      return {
        ...state,
        submittedAddress: action.payload,
      };
    case 'RESET_ADDRESS_FIELDS':
      return {
        ...state,
        addressFieldsValues: {
          [`${state.id}Number`]: '',
          [`${state.id}Line1`]: '',
          [`${state.id}Line2`]: '',
          [`${state.id}Line3`]: '',
          [`${state.id}Line4`]: '',
          [`${state.id}Postcode`]: '',
        },
      };
    case 'POPULATE_ADDRESS_FIELDS':
      return {
        ...state,
        addressFieldsValues: {
          ...state.addressFieldsValues,
          ...action.payload,
        },
      };
    case 'SET_ADDRESS_FIELD':
      return {
        ...state,
        addressFieldsValues: {
          ...state.addressFieldsValues,
          [action.field]: action.payload,
        },
      };
    default:
      return state;
  }
};
